(function () {
  var WEBWINKELKEUR_SRC = "https://dashboard.webwinkelkeur.nl/sidebar.js?id=1220996";
  var DESKTOP_QUERY = "(min-width: 1200px)";
  var INTENT_SELECTOR = [
    "[data-mobile-menu-toggle]",
    "[data-trust-toggle]",
    "[data-reviews-modal-trigger]",
    ".review-modal__footer-link",
    "valued-widget"
  ].join(",");
  var loaded = false;
  var intentObserver = null;

  function isDesktop() {
    return window.matchMedia && window.matchMedia(DESKTOP_QUERY).matches;
  }

  function cleanup() {
    document.removeEventListener("click", handleIntent, true);
    document.removeEventListener("focusin", handleIntent, true);
    if (intentObserver) {
      intentObserver.disconnect();
      intentObserver = null;
    }
  }

  function loadWebwinkelkeur() {
    if (loaded || document.querySelector('script[data-webwinkelkeur-sidebar="true"]')) return;
    loaded = true;
    cleanup();

    var script = document.createElement("script");
    script.src = WEBWINKELKEUR_SRC;
    script.async = true;
    script.dataset.webwinkelkeurSidebar = "true";
    document.head.appendChild(script);
  }

  function handleIntent(event) {
    var target = event.target && event.target.closest
      ? event.target.closest(INTENT_SELECTOR)
      : null;
    if (target) loadWebwinkelkeur();
  }

  function observeWidgetIntent() {
    if (!("IntersectionObserver" in window)) return;

    var widgets = document.querySelectorAll("valued-widget");
    if (!widgets.length) return;

    intentObserver = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i += 1) {
        if (entries[i].isIntersecting) {
          loadWebwinkelkeur();
          break;
        }
      }
    }, {
      rootMargin: "600px 0px"
    });

    widgets.forEach(function (widget) {
      intentObserver.observe(widget);
    });
  }

  if (isDesktop()) {
    loadWebwinkelkeur();
    return;
  }

  document.addEventListener("click", handleIntent, true);
  document.addEventListener("focusin", handleIntent, true);
  observeWidgetIntent();
})();
